import { Link } from "react-router-dom";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function NotFound() {
  usePageMeta({
    title: "页面未找到 - 51爆料网",
    description: "你访问的页面不存在或已被移除，请返回51爆料网首页查看更多爆料与热点资讯。",
    keywords: "51爆料网,页面未找到,404",
  });

  return (
    <div className="mx-auto flex max-w-[1280px] flex-col items-center justify-center px-4 py-24 text-center md:px-6">
      <span className="flex h-20 w-20 items-center justify-center rounded-2xl bg-primary-100 text-primary-600">
        <i className="ri-emotion-sad-line text-4xl" />
      </span>
      <h1 className="mt-6 font-heading text-3xl font-black text-foreground-950">404</h1>
      <p className="mt-2 text-lg font-semibold text-foreground-800">页面走丢了</p>
      <p className="mt-3 max-w-md text-sm text-foreground-500">
        你访问的链接可能已失效或被移除。不妨回到首页，看看今天最新的爆料与热点。
      </p>
      <div className="mt-7 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line" />
          返回首页
        </Link>
        <Link
          to="/category/all"
          className="flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          <i className="ri-apps-2-line" />
          浏览全部爆料
        </Link>
      </div>
    </div>
  );
}